<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#2D3436" title="">
      <!-- <v-row> -->
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          dark
          small
          color="success"
          @click="$router.push({
            name: 'Home'
          });"
        >
          Menú
        </v-btn>
        <br/>
        <br/>
        <v-row>
          <v-col sm="12" xs="12" md="3">
            <div class="panel1-detalle">
                    
                    <v-list
                      style="background: transparent;"
                    >
                        <v-list-item-group color="primary">
                            <v-list-item
                            @click="$router.go(-1)"

                            >
                                <v-list-item-icon>
                                  <v-icon>mdi-chevron-left</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                  <v-list-item-title>Atrás</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item
                            >
                                <v-list-item-icon>
                                  <v-icon>mdi-lock-open</v-icon>
                                </v-list-item-icon>

                                <v-list-item-content>
                                  <v-list-item-title>Solicitar acceso</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        
                        </v-list-item-group>
                    </v-list>
                </div>
                
          </v-col>
          <v-col xs="12" sm="12" md="9" v-if="foro">
            <template>
              <v-card
                class="mx-auto"
              >
                <v-toolbar flat>
                  <v-toolbar-title >
                    {{foro.title}}
                    <v-chip
                      v-if="foro.type=='private'"
                        color="primary"
                        small
                      >
                      <v-icon>mdi-lock</v-icon> Privado
                      </v-chip>
                  </v-toolbar-title>

                  <v-spacer></v-spacer>
                   <v-toolbar-title>{{foro.likes}}</v-toolbar-title>
                  <v-btn icon @click="like" :disabled="liked">
                    <v-icon>mdi-thumb-up-outline</v-icon>
                  </v-btn>
                  <v-btn icon @click="dislike" :disabled="disliked">
                    <v-icon>mdi-thumb-down-outline</v-icon>
                  </v-btn>

                 
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text>
                  
                  <v-row>
                    <v-col xs="1" sm="1" md="1">
                      <v-avatar size="60" color="#636E72" style="border:6px solid #e5e3e2">
                      <v-img :src="foro.alumno.imagen"></v-img>
                      </v-avatar>
                    </v-col>
                    <v-col xs="11" sm="11" md="11">
                      <div class="text-xs-h6 text-sm-h6 text-md-h6 text-lg-h6 text-xl-h6">{{foro.alumno.Nombres}} {{foro.alumno.Apellidos}}</div>
                      <small class="primary--text">{{foro.created_at}}</small>
                      <div class="text-xs-h6 text-sm-h6 text-md-h6 text-lg-h6 text-xl-h6" :style="{'color':foro.category.color}">{{foro.category.name}}</div>
                      <p v-html="foro.content" class="content-forum"></p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-carousel 
                      hide-delimiters
                      :show-arrows="(foro.images.length >= 2) || (foro.images.length  == 1 && foro.video) ? true: false"
                      v-if="foro.images.length >= 2 || foro.video"
                      height="300"  
                      >
                      <v-carousel-item
                        v-for="(image,j) in foro.images.filter(d => {return (d.status == 1)})"
                        :key="j"
                        :src="image.image"
                        @click="openPublication(foro)"
                      ></v-carousel-item>
                      <v-carousel-item
                        v-if="foro.video"
                      >
                      <video width="100%" height="400" controls>
                          <source :src="foro.video" type="video/mp4">
                      </video>
                      </v-carousel-item>
                    </v-carousel>
                     <v-img v-if="foro.images.length == 1" :src="foro.images[0].image" ></v-img>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>


            <br/><br/><br/>
            <v-row>
              <v-col xs="1" sm="1" md="1">
                <v-avatar size="50" color="#636E72" style="border:3px solid #e5e3e2">
                <v-img :src="user.imagen"></v-img>
                </v-avatar>
              </v-col>
              <v-col xs="11" sm="11" md="11">
                <v-textarea
                  solo
                  name="input-7-4"
                  label="Responder"
                  rows="4"
                  v-model="comment"
                ></v-textarea>
                <v-btn
                  depressed
                  color="primary"
                  @click="addComment()"
                >
                  Enviar
                </v-btn>
              </v-col>
            </v-row>
            <br>
            <div v-if="foro.comments.length > 0">
              <div class="text-xs-h6 text-sm-h6 text-md-h6 text-lg-h6 text-xl-h6" style="color:#464646;">{{foro.comments.length}} comentarios</div>
              <v-timeline
                align-top
                dense
              >
                <v-timeline-item
                    v-for="(comment,j) in foro.comments"
                    :key="j"
                    large
                    color="#636E72"
                >
                    <template v-slot:icon>
                        <v-avatar size="50" title="Ver perfil">
                           <div class="v-image v-responsive theme--light"><div class="v-responsive__sizer" style="padding-bottom: 190.399%;"></div><div class="v-image__image v-image__image--cover" v-bind:style="{ 'background-image': 'url(' + comment.alumno.imagen + ')','background-position': 'center center' }"></div><div class="v-responsive__content" style="width: 1229px;"></div></div>
                        </v-avatar>
                    </template>
                  <v-card class="elevation-2">
                      <v-card-actions style="padding-left: 20px;" >
                      <v-spacer></v-spacer>
                      <v-btn
                        icon
                        v-if="comment.alumno_id == user.IDStB"
                        @click="deleteComment(comment, j)"
                      >
                        <v-icon small color="grey">mdi-delete</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        v-else
                      >
                      </v-btn>
                    </v-card-actions>
                    <v-card-text style="margin-top: -50px">
                      <strong>{{comment.alumno.Nombres}}</strong><br/>
      
                      <p class="mb-5" style="color:#464646" v-html="comment.comment"></p>
                      <small class="primary--text">Hace {{gettime(comment.updated_at)}}</small> <small class="warning--text" style="margin-left: 10px;">
                        <v-btn icon @click="likeComment(comment)"  class="warning--text">{{comment.likes}}
                          <v-icon  color="orange" small>mdi-thumb-up-outline</v-icon>
                        </v-btn></small><br>
                    </v-card-text>
                    
                    </v-card>
                </v-timeline-item>
              </v-timeline>
            </div>
            <div v-else>
              <v-alert
              
                type="info"

              >
               Sé el primero en comentar
              </v-alert>
            </div>
          </v-col>
        </v-row>
      </v-col>
     
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";
import moment from "moment";
moment.locale('es')


export default {
  name: "Chat",
  components: {
    // CardIeaApp,
    CardIeaAppMain,

    
  },

  data: () => ({
    categories:[],
    selectedCategory:0,
    foro:null,
    comment:'',
    liked:false,
    disliked:false
    
  }),
  mounted() {
    if(this.$store.getters.user.borrado == 1 ||  this.$store.getters.user.alumno_mora ==  true || this.$store.getters.user.excedente){
      this.$router.push({
          name: "Home"
        });
    }
    this.foro = this.$route.params.foro;
    this.getCategories();
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },

  methods: {
    gettime(date_publish){
      let current_date = moment();
      let published_date = moment(date_publish);
      return (moment.duration(current_date - published_date).humanize())
    },
    async addComment(){

      var formData = new FormData();
      formData.append('comment',this.comment);
      formData.append('taged','');

      await this.$API
        .post({
          url: "forums-comment/" + this.foro.id,
          data: formData
        }).then(res => {
            console.log(res)
            this.foro.comments.unshift(res);
            this.comment = '';
        });
      
    },

    async like(){
      await this.$API
        .post({
          url: "forums-like/" + this.foro.id,
          data: {}
        }).then(res => {
          if(res){
            this.foro.likes ++;
            this.liked = true;
          }
        });
    },

    async likeComment(comment){
      await this.$API
        .post({
          url: "forums-comment-like/" + comment.id,
          data: {}
        }).then(res => {
          if(res){
            comment.likes ++;
          }
        });
    },
    async dislike(){
      await this.$API
        .delete({
          url: "forums-like/" + this.foro.id,
          data: {}
        }).then(res => {
          if(res){
            this.foro.likes --;
            this.disliked = true;
          }
        });
    },

    async deleteComment(comment, j){
      if(confirm('¿Estas seguro de querer eliminar este comentario?')){
        await this.$API
        .delete({
          url: "forums-comment/" + comment.id,
          data: {}
        }).then(res => {
          if(res){
            this.foro.comments.splice(j, 1)
          }
        });
      } 
    },


    async getCategories() {
      await this.$API
        .get({
          url: "forum-categories",
          data: {}
        })
        .then(res => {
          this.categories = res;
        });
    },
  }
};
</script>

